import { baseImageUrl, baseURL } from "../../api";
import { setMyGarageMultipleFields } from "../../toolkit/myGarage/myGarageSlice";
import { questionareFields } from "../constants/backendFieldsMappings/getVehicleDataMappings";
import { mileageUnits } from "../constants/myGarage";
import { DrivingCondition } from "../constants/sellMyCar";

const getGeneralInfo = ({data}) => {
  const exteriorDamage = [];
  const interiorDamage = [];
  const accessories = [];
  const tires = [];

  if (data?.vehicle?.["2_Sets_Of_Tire"]) {
    tires.push("2 Sets of Tires");
  }

  if (data?.vehicle?.Win_Tint) {
    tires.push("Window Tint");
  }

  if (data?.vehicle?.Aftermark_Exhaust) {
    tires.push("Aftermarket Wheels");
  }

  if (data?.vehicle?.Aftermark_Rims) {
    tires.push("Aftermarket Rims");
  }

  if (data?.vehicle?.Roof_Rack) {
    tires.push("Roof Racks");
  }

  //

  if (data?.vehicle?.["Minor_Damage"]) {
    exteriorDamage.push("Minor Damage");
  }

  if (data?.vehicle?.Fading_Paints) {
    exteriorDamage.push("Fading Paints");
  }

  if (data?.vehicle?.Rust) {
    exteriorDamage.push("Rust");
  }

  if (data?.vehicle?.Hail_Damage) {
    exteriorDamage.push("Hail Damage");
  }

  if (data?.vehicle?.Ext_Mint_Condition) {
    exteriorDamage.push("Mint condition");
  }

  if (data?.vehicle?.Dents) {
    exteriorDamage.push("Dents");
  }

  if (data?.vehicle?.["Minor_Damage"]) {
    exteriorDamage.push("Minor Damage");
  }

  if (data?.vehicle?.Fading_Paints) {
    exteriorDamage.push("Fading Paints");
  }

  if (data?.vehicle?.Rust) {
    exteriorDamage.push("Rust");
  }

  if (data?.vehicle?.Hail_Damage) {
    exteriorDamage.push("Hail Damage");
  }

  if (data?.vehicle?.Ext_Mint_Condition) {
    exteriorDamage.push("Mint condition");
  }

  if (data?.vehicle?.Dents) {
    exteriorDamage.push("Dents");
  }

  //
  if (data?.vehicle?.["Seats_Rips_Tears"]) {
    interiorDamage.push("Rips on Seats");
  }

  if (data?.vehicle?.Seats_Visible_Stain) {
    interiorDamage.push("Visible Stains");
  }

  if (data?.vehicle?.Strong_Smell) {
    interiorDamage.push("Strong Smell");
  }

  if (data?.vehicle?.Int_Mint_Condition) {
    interiorDamage.push("Mint condition");
  }

  if (data?.vehicle?.Nav_Entmt_Ctrl_Dmg_Sys) {
    interiorDamage.push("Damaged Systems");
  }

  if (data?.vehicle?.Other_Interior_Damage) {
    interiorDamage.push("Others");
  }

  //
  if (data?.vehicle?.["Remote_Start"]) {
    accessories.push("Remote Starter");
  }

  if (data?.vehicle?.Aftermark_Stereo) {
    accessories.push("Aftermarket Stereo");
  }

  if (data?.vehicle?.Aftermark_Spoiler) {
    accessories.push("Aftermarket Spoiler");
  }
  //

  const generalInfo = {
    VIN: data?.vehicle?.VIN || "",
    Location: data?.vehicle?.Location || "",
    Year: data?.vehicle?.Year || "",
    Make: data?.vehicle?.Make || "",
    Model: data?.vehicle?.Model || "",
    Trim: data?.vehicle?.Trim || "",
    Mileage: data?.vehicle?.Mileage || "",
    Mileage_Unit: data?.vehicle?.Mileage_Unit || mileageUnits.km,
    color: data?.vehicle?.Color || "",
    key: data?.vehicle?.Car_Keys || "",
    transmission: data?.vehicle?.Transmission_Type || "",
    check_driving_condition: data?.vehicle?.check_driving_condition || "",
    interiorDamage: interiorDamage || "",
    exteriorDamage: exteriorDamage || "",
    tires: tires || "",
    accessories: accessories || "",
    drivingCondition: data?.vehicle?.drivingCondition || ""
  };

  return generalInfo;
};

const getQuestionareHandler = ({ data }) => {
  console.log("asd", data);
  console.log("sad", typeof data?.vehicle?.Smoke_In_Vehicle);
  const questionare = {
    [questionareFields.Smoke_In_Vehicle]: typeof data?.vehicle?.Smoke_In_Vehicle === "number" ? data?.vehicle?.Smoke_In_Vehicle : "",
    [questionareFields.Original_Factory_Rims]: typeof data?.vehicle?.Original_Factory_Rims === "number" ? data?.vehicle?.Original_Factory_Rims : "",
    [questionareFields.Tires_Repld_12_Months]: typeof data?.vehicle?.Tires_Repld_12_Months === "number" ? data?.vehicle?.Tires_Repld_12_Months : "",
    [questionareFields.Windshield_Crack]: typeof data?.vehicle?.Windshield_Crack === "number" ? data?.vehicle?.Windshield_Crack : "",
    [questionareFields.Extended_Warranty]: typeof data?.vehicle?.Extended_Warranty === "number" ? data?.vehicle?.Extended_Warranty : "",
    [questionareFields.Vehicle_Drivable]: typeof data?.vehicle?.Vehicle_Drivable === "number" ? data?.vehicle?.Vehicle_Drivable : "",
    [questionareFields.vehicle_drivable_not_explanation]: data?.vehicle?.vehicle_drivable_not_explanation || ""
  };

  return questionare;
};

const getImagesHandler = ({
  data
}) => {
  const gallery = {
    Vehicle_video: data?.vehicle?.Vehicle_video || "",
    images: {
      ["Interior Of The Car"]: [
        data?.vehicle?.Interior_Image
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image}`
          : "",
        data?.vehicle?.Interior_Image2
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image2}`
          : "",
        data?.vehicle?.Interior_Image3
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image3}`
          : "",
        data?.vehicle?.Interior_Image4
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image4}`
          : "",
      ],
      ["Exterior Of The Car"]: [
        data?.vehicle?.Exterior_Image
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image}`
          : "",
        data?.vehicle?.Exterior_Image2
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image2}`
          : "",
        data?.vehicle?.Exterior_Image3
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image3}`
          : "",
        data?.vehicle?.Exterior_Image4
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image4}`
          : "",
      ],
      ["Rims Of The Car"]: [
        data?.vehicle?.Rims_Image
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image}`
          : "",
        data?.vehicle?.Rims_Image2
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image2}`
          : "",
        data?.vehicle?.Rims_Image3
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image3}`
          : "",
        data?.vehicle?.Rims_Image4
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image4}`
          : "",
      ],
      ["Damage Photos"]: [
        data?.vehicle?.Dashboard_Image
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image}`
          : "",
        data?.vehicle?.Dashboard_Image2
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image2}`
          : "",
        data?.vehicle?.Dashboard_Image3
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image3}`
          : "",
        data?.vehicle?.Dashboard_Image4
          ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image4}`
          : "",
      ],
      // ["Other Pictures"]: [],
    },
  };

  return gallery;
}

const setSellMyCarFormsHandler = ({
  dispatch,
  data,
  successCallback,
  setGeneralInfoForm,
  setQuestionareForm,
  setSpecificationsForm,
  setGalleryForm,
  forms,
  previouslySubmittedForms,
}) => {
  // dispatch(
  //   setGeneralInfoForm({
  //     VIN: data?.vehicle?.VIN || "",
  //     Location: data?.vehicle?.Location || "",
  //     Year: data?.vehicle?.Year || "",
  //     Make: data?.vehicle?.Make || "",
  //     Model: data?.vehicle?.Model || "",
  //     Trim: data?.vehicle?.Trim || "",
  //     Mileage: data?.vehicle?.Mileage || "",
  //     color: data?.vehicle?.Color || "",
  //     key: data?.vehicle?.Car_Keys || "",
  //     transmission: data?.vehicle?.Transmission_Type || "",
  //     interiorDamage: interiorDamage || "",
  //     exteriorDamage: exteriorDamage || "",
  //     tires: tires || "",
  //     accessories: accessories || ""
  //   })
  // );

  // dispatch(
  //   setQuestionareForm({
  //     Smoke_In_Vehicle: data?.vehicle?.Smoke_In_Vehicle || "",
  //     Original_Factory_Rims: data?.vehicle?.Original_Factory_Rims || "",
  //     Tires_Repld_12_Months: data?.vehicle?.Tires_Repld_12_Months || "",
  //     Windshield_Crack: data?.vehicle?.Windshield_Crack || "",
  //     Extended_Warranty: data?.vehicle?.Extended_Warranty || "",
  //     Vehicle_Drivable: data?.vehicle?.Vehicle_Drivable || "",
  //     vehicle_drivable_not_explanation: data?.vehicle?.vehicle_drivable_not_explanation || ""
  //   })
  // );

  const features = data?.vehicle?.Additional_Car_Feature?.split(",")?.map?.(
    (item) => {
      return [item?.trim?.()];
    }
  );

  const registration = [];

  if (data?.vehicle?.MTO_Irreparable) {
    registration.push("MTO_Irreparable");
  }

  if (data?.vehicle?.MTO_Rebuilt) {
    registration.push("MTO_Rebuilt");
  }

  if (data?.vehicle?.MTO_Salvage) {
    registration.push("MTO_Salvage");
  }

  if (data?.vehicle?.MTO_None) {
    registration.push("MTO_None");
  }

  // dispatch(
  //   setSpecificationsForm({
  //     Car_Condition: data?.vehicle?.Car_Condition || "",
  //     features: features?.reduce((accumulator, currentValue) => {
  //       accumulator[currentValue] = 1;
  //       return accumulator;
  //     }, {}),
  //     registration: registration?.reduce((accumulator, currentValue) => {
  //       accumulator[currentValue] = true;
  //       return accumulator;
  //     }, {}),
  //     Car_Notes: data?.vehicle?.Car_Notes || ""
  //   })
  // );

  // dispatch(
  //   setGalleryForm({
  //     Vehicle_video: data?.vehicle?.Vehicle_video || "",
  //     images: {
  //       ["Interior Of The Car"]: [
  //         data?.vehicle?.Interior_Image ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image}` : "",
  //         data?.vehicle?.Interior_Image2 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image2}` : "",
  //         data?.vehicle?.Interior_Image3 ?`${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image3}` : "",
  //         data?.vehicle?.Interior_Image4 ?`${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Interior_Image4}` : ""
  //       ],
  //       ["Exterior Of The Car"]: [
  //         data?.vehicle?.Exterior_Image ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image}` : "",
  //         data?.vehicle?.Exterior_Image2 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image2}` : "",
  //         data?.vehicle?.Exterior_Image3 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image3}` : "",
  //         data?.vehicle?.Exterior_Image4 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Exterior_Image4}` : ""
  //       ],
  //       ["Rims Of The Car"]: [
  //         data?.vehicle?.Rims_Image ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image}` : "",
  //         data?.vehicle?.Rims_Image2 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image2}` : "",
  //         data?.vehicle?.Rims_Image3 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image3}` : "",
  //         data?.vehicle?.Rims_Image4 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Rims_Image4}` : ""
  //       ],
  //       ["Damage Photos"]: [
  //         data?.vehicle?.Dashboard_Image ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image}` : "",
  //         data?.vehicle?.Dashboard_Image2 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image2}` : "",
  //         data?.vehicle?.Dashboard_Image3 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image3}` : "",
  //         data?.vehicle?.Dashboard_Image4 ? `${baseImageUrl}${data?.vehicle?.Vehicle_Id}/${data?.vehicle?.Dashboard_Image4}` : ""
  //       ],
  //       ["Other Pictures"]: [],
  //     },
  //   })
  // );

  const generalInfo = getGeneralInfo({
    data,
  });
  // const generalInfo = {
  //   VIN: data?.vehicle?.VIN || "",
  //   Location: data?.vehicle?.Location || "",
  //   Year: data?.vehicle?.Year || "",
  //   Make: data?.vehicle?.Make || "",
  //   Model: data?.vehicle?.Model || "",
  //   Trim: data?.vehicle?.Trim || "",
  //   Mileage: data?.vehicle?.Mileage || "",
  //   color: data?.vehicle?.Color || "",
  //   key: data?.vehicle?.Car_Keys || "",
  //   transmission: data?.vehicle?.Transmission_Type || "",
  //   interiorDamage: interiorDamage || "",
  //   exteriorDamage: exteriorDamage || "",
  //   tires: tires || "",
  //   accessories: accessories || ""
  // };

  const questionare = getQuestionareHandler({
    data,
  });
  // const questionare = {
  //   Smoke_In_Vehicle: typeof data?.vehicle?.Smoke_In_Vehicle === "number" ? data?.vehicle?.Smoke_In_Vehicle : "",
  //   Original_Factory_Rims: typeof data?.vehicle?.Original_Factory_Rims === "number" ? data?.vehicle?.Original_Factory_Rims : "",
  //   Tires_Repld_12_Months: typeof data?.vehicle?.Tires_Repld_12_Months === "number" ? data?.vehicle?.Tires_Repld_12_Months : "",
  //   Windshield_Crack: typeof data?.vehicle?.Windshield_Crack === "number" ? data?.vehicle?.Windshield_Crack : "",
  //   Extended_Warranty: typeof data?.vehicle?.Extended_Warranty === "number" ? data?.vehicle?.Extended_Warranty : "",
  //   Vehicle_Drivable: typeof data?.vehicle?.Vehicle_Drivable === "number" ? data?.vehicle?.Vehicle_Drivable : "",
  //   vehicle_drivable_not_explanation: data?.vehicle?.vehicle_drivable_not_explanation || ""
  // };

  const specifications = {
    Car_Condition: data?.vehicle?.Car_Condition || "",
    features:
      features?.reduce((accumulator, currentValue) => {
        accumulator[currentValue] = 1;
        return accumulator;
      }, {}) || {},
    registration:
      registration?.reduce((accumulator, currentValue) => {
        accumulator[currentValue] = true;
        return accumulator;
      }, {}) || {},
    Car_Notes: data?.vehicle?.Car_Notes || "",
  };

  const gallery = getImagesHandler({
    data
  });

  dispatch(
    setMyGarageMultipleFields({
      forms: {
        ...forms,
        generalInfo,
        questionare,
        specifications,
        gallery,
      },
      previouslySubmittedForms: {
        ...previouslySubmittedForms,
        generalInfo,
        questionare,
        specifications,
        gallery,
      },
    })
  );

  if (successCallback) {
    successCallback();
  }
};

export { 
  setSellMyCarFormsHandler, getGeneralInfo, getQuestionareHandler,
  getImagesHandler
};
